export const environment = {
  production: false,
  authUrl: 'https://testbasismartgo.smart.edu.co',
  apiUrl: 'https://testbdcpsmartgo.smart.edu.co',
};